/**
 * インターバル時間を営業時間中の時間として扱うカレンダー操作をするクラス
 */
import * as time from '@/libs/time'
import Calendar from './base'

export default class StrictCalendar extends Calendar {
  /**
   * 予約開始日時にインターバル時間を確保する
   *
   * @param {Date} d 元の予約開始日時
   * @param {Number} intervalHours インターバル時間
   * @returns {Date} 予約開始日時を返す
   */
  securedBegin (d, intervalHours) {
    d.setTime(d.getTime() - (intervalHours * time.HOUR))
    if (d < this._begin) {
      d.setTime(this._begin.getTime())
    }

    // 営業時間内に収める
    while (true) {
      // 営業時間外かテストする
      const close = this.testClosed(d, true, false)
      if (!close) {
        break
      }
      if (!close.begin) {
        return null
      }

      // d 〜 close.end までの時間(残り時間)を得る
      const delta = close.end ? (close.end - d) : 0

      // close.begin から残り時間を過去に向かって加算する
      d.setTime(close.begin.getTime() - delta)
    }
    return d
  }

  /**
   * 予約終了日時にインターバル時間を確保する
   *
   * @param {Date} d 元の予約終了日時
   * @param {Number} intervalHours インターバル時間
   * @returns {Date} 予約終了日時を返す
   */
  securedEnd (d, intervalHours) {
    d.setTime(d.getTime() + (intervalHours * time.HOUR))
    if (this._end < d) {
      d.setTime(this._end.getTime())
    }

    // 営業時間内に収める
    while (true) {
      // 営業時間外かテストする
      const close = this.testClosed(d, false, true)
      if (!close) {
        break
      }
      if (!close.end) {
        return null
      }

      // close.begin 〜 d までの時間(残り時間)を得る
      const delta = close.begin ? (d - close.begin) : 0

      // close.begin から残り時間を未来に向かって加算する
      d.setTime(close.end.getTime() + delta)
    }
    return d
  }
}
